import { render, staticRenderFns } from "./TodoCard.vue?vue&type=template&id=613c1c61&scoped=true&lang=ru"
import script from "./TodoCard.vue?vue&type=script&lang=js"
export * from "./TodoCard.vue?vue&type=script&lang=js"
import style0 from "./TodoCard.vue?vue&type=style&index=0&id=613c1c61&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "613c1c61",
  null
  
)

export default component.exports